/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_121Inputs */

const cs_ares_legal_form_121 = /** @type {(inputs: Ares_Legal_Form_121Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akciová společnost`)
};

const en_ares_legal_form_121 = /** @type {(inputs: Ares_Legal_Form_121Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joint-stock company`)
};

/**
* | output |
* | --- |
* | "Joint-stock company" |
*
* @param {Ares_Legal_Form_121Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_121 = /** @type {((inputs?: Ares_Legal_Form_121Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_121Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_121(inputs)
	return cs_ares_legal_form_121(inputs)
});